import React from "react"
import { buildRow, getLabel } from "../../util/FormatUtil";
import { getConvertedValue } from "../resultReports/helpers/utils";
import { sweetalert } from "../../App";
import Overlay from "../Overlay";
import { confirmAlreadyViewed, downloadSampleDocuments, promptDocumentSelection } from "../../util/SampleDocumentsUtil";
import { demoEssentialAndComprehensiveServiceIDs, demoEssentialNonUpgradeableServiceIDs, demoEssentialUpgradeableServiceIDs, developmentEssentialAndComprehensiveServiceIDs, devEssentialNonUpgradableServiceIDs, devEssentialUpgradableServiceIDs, productionEssentialAndComprehensiveServiceIDs, productionEssentialNonUpgradableServiceIDs, productionEssentialUpgradableServiceIDs } from "../../types/Service";


interface ViewTestInfoModalState{
    showLoading:boolean
    pdfDataURL
}

interface ViewTestInfoModalProps{
    selectedSample
    tests
    results
    services?
    onReportDownloaded?: (reqNum: string) => void
}



class ViewTestInfoModal extends React.Component<ViewTestInfoModalProps, ViewTestInfoModalState>{
    public static ID = "ViewTestInfo"
    constructor(props) {
        super(props);
        this.state = {
            showLoading: false,
            pdfDataURL: ''
        };
    }

    // Lets the user pick documents (requisition and STARLIMS reports) and opens them as one merged PDF.
    async openDocuments() {
        const reqNum = this.props.selectedSample?.ReqNum;
        if (!reqNum) {
          return sweetalert.fire({ icon: 'error', title: '', text: 'No requisition number found for this sample.' });
        }
        const documentTypes = await promptDocumentSelection(`Documents - ${reqNum}`);
        if (!documentTypes) {
          return;
        }
        if (!(await confirmAlreadyViewed([reqNum], documentTypes, loading => this.setState({ showLoading: loading })))) {
          return;
        }
        this.setState({ showLoading: true });
        const downloaded = await downloadSampleDocuments([reqNum], documentTypes);
        this.setState({ showLoading: false });
        if (downloaded.length > 0) {
          this.props.onReportDownloaded?.(reqNum);
        }
    }

    render() {
        let testAndResultsArray = []
        let tempMap;
        let tempIDs;
        let hasAdditionalResultValue = false
        let noTests = false
        let selectedService = this.props.services && this.props.services.length > 0 && this.props.selectedSample ? this.props.services.find(f => f.ID === this.props.selectedSample.ServiceID) : null; 

        let isEssentialOrComprehensive;

        if(this.props.selectedSample.TestIDs){
            tempIDs = JSON.parse(this.props.selectedSample.TestIDs).filter(id => id !== null)
        }

        
        if(selectedService && selectedService.ID){
            if(process.env.REACT_APP_ENV === 'production'){
              if(productionEssentialAndComprehensiveServiceIDs.includes(selectedService.ID)){
                  isEssentialOrComprehensive = true;            
              }
            }
            else if(process.env.REACT_APP_ENV === 'demo'){
              if(demoEssentialAndComprehensiveServiceIDs.includes(selectedService.ID)){
                  isEssentialOrComprehensive = true;
              }
            }
            else{
                if(developmentEssentialAndComprehensiveServiceIDs.includes(selectedService.ID)){
                    isEssentialOrComprehensive = true;
                }
            }
          }

          
  
          if(this.props.selectedSample.TestsAndResultsMap){
              tempMap = JSON.parse(this.props.selectedSample.TestsAndResultsMap)
              const allProdEssentialServiceIDs = productionEssentialNonUpgradableServiceIDs.concat(productionEssentialUpgradableServiceIDs);
              const allDevEssentialServiceIDs = devEssentialNonUpgradableServiceIDs.concat(devEssentialUpgradableServiceIDs);
              const allDemoEssentialServiceIDs = demoEssentialNonUpgradeableServiceIDs.concat(demoEssentialUpgradeableServiceIDs);

              if(selectedService && selectedService.ID && isEssentialOrComprehensive){
                  let temp = [];
                  if(process.env.REACT_APP_ENV === 'production' && allProdEssentialServiceIDs.includes(selectedService.ID)){
                      if(allProdEssentialServiceIDs.includes(selectedService.ID)){
                          temp = tempMap.filter(item => tempIDs.includes(item.TestID));
                      }
                  }
                  else if(process.env.REACT_APP_ENV === 'demo' && allDemoEssentialServiceIDs.includes(selectedService.ID)){
                    if(allDemoEssentialServiceIDs.includes(selectedService.ID)){
                        temp = tempMap.filter(item => tempIDs.includes(item.TestID));           
                    }
                  }
                  else if(allDevEssentialServiceIDs.includes(selectedService.ID)){
                          temp = tempMap.filter(item => tempIDs.includes(item.TestID));           
                  }
                  else{
                      temp = tempMap;
                  }
  
                tempMap = temp;
              }
          }


        //get results that have AllowNonStandardResultValue flag set to true
        let resultsThatAllowNonStandard = this.props.results?.filter(r => r.AllowNonStandardResultValue);
        resultsThatAllowNonStandard = resultsThatAllowNonStandard?.map(r => {return r.value})

        if(tempIDs && tempIDs?.length === 0){
            //has no tests
            noTests = true
        }
        else if(tempMap && tempMap?.length === tempIDs?.length){
            //every test has a result
            let temp = []
            for (let i = 0; i < tempMap.length; i++) {
                const tempMapElement = tempMap[i];
                
                if(resultsThatAllowNonStandard.includes(tempMapElement.ResultID)){
                    temp.push({Test: (getLabel(tempMapElement.TestID, this.props.tests)?.label ?? 'Unknown test'), Result: (getLabel(tempMapElement.ResultID, this.props.results)?.label ?? 'No Result'), ResultValue: tempMapElement.ResultValue})
                    hasAdditionalResultValue = true
                }
                else{
                    temp.push({Test: (getLabel(tempMapElement.TestID, this.props.tests)?.label ?? 'Unknown test'), Result: (getLabel(tempMapElement.ResultID, this.props.results)?.label ?? 'No Result')})
                }
            }
            testAndResultsArray = temp
        }
        else if(tempIDs && (!tempMap || tempMap?.length === 0) && tempIDs?.length > 0){
            //has test but no results
            for (let i = 0; i < tempIDs.length; i++) {
               const element = tempIDs[i];
               testAndResultsArray.push({Test: (getLabel(element, this.props.tests)?.label ?? 'Unknown test'), Result: 'No Result'})
            }
        }
        else if(tempMap && tempIDs && tempMap?.length > 0 && tempIDs?.length > 0 && tempIDs?.length !== tempMap?.length){
            //not every test has result
            let temp = []
            let notIncluded = []
            for (let i = 0; i < tempMap.length; i++) {
                const tempMapElement = tempMap[i];
                if(resultsThatAllowNonStandard.includes(tempMapElement.ResultID)){
                    temp.push({Test: (getLabel(tempMapElement.TestID, this.props.tests)?.label ?? 'Unknown test'), Result: tempMapElement.ResultID ? (getLabel(tempMapElement.ResultID, this.props.results)?.label ?? 'No Result') : 'No Result', ResultValue: tempMapElement.ResultValue})
                    hasAdditionalResultValue = true
                }
                else{
                    temp.push({Test: (getLabel(tempMapElement.TestID, this.props.tests)?.label ?? 'Unknown test'), Result: tempMapElement.ResultID ? (getLabel(tempMapElement.ResultID, this.props.results)?.label ?? 'No Result') : 'No Result'})
                }
            }
            for (let i = 0; i < tempIDs.length; i++) {
                const tempIDsElement = tempIDs[i];
                if(!tempMap.find(t => t.TestID === tempIDsElement)){
                    notIncluded.push(tempIDsElement)
                }
            }

            for (let i = 0; i < notIncluded.length; i++) {
                const element = notIncluded[i];
                temp.push({Test: (getLabel(element, this.props.tests)?.label ?? 'Unknown test'), Result: 'No Result'})
            }

            testAndResultsArray = temp

        }

        return (
        <>
            <Overlay show_loading={this.state.showLoading} zIndex={100005} />
            <div className="modal fade form_modal" id={ViewTestInfoModal.ID} tabIndex={-1} role="dialog"
                 aria-label="Test Info"
                 aria-hidden="true">
                <div className="modal-dialog modal-lg modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-body p-0 m-0">
                            <div className="container-fluid  min-vh-10">
                                <div className={"row"}>
                                    <div className="col-12 pt-2">
                                        <div className="card mb-2 text-center">
                                            <div className="card-header verlag-bold">
                                                <h4 style={{fontWeight: 'bold'}}>Test Info
                                                    <button style={{outline: 'none'}}  type="button" className="close pr-4" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true" style={{fontSize: '1.5em', fontWeight: 'bold'}}>&times;</span>
                                                    </button>
                                                </h4>
                                            </div>
                                            <div className="card-body">
                                                {noTests ? (
                                                    <div>No Tests Assigned</div>
                                                ) :
                                                isEssentialOrComprehensive ? 
                                                testAndResultsArray && testAndResultsArray.length > 0 && testAndResultsArray.map(t => (
                                                    <div className="row">
                                                    <div className={"col-5 pl-md-0 ml-md-0"}>
                                                        {buildRow("Test",
                                                            <input className="form-control ml-2 ml-md-0"
                                                                type={"text"}
                                                                name={t.Test}
                                                                value={t.Test}
                                                                disabled={true}
                                                            />
                                                        )}
                                                    </div>
                                                    <div className={"col-6 ml-md-0"}>
                                                        {buildRow("Result Value",
                                                            <input className="form-control ml-2 ml-md-0"
                                                                type={"text"}
                                                                name={t.ResultValue || t.ResultValue === 0 ? t.ResultValue : ''}
                                                                value={t.ResultValue || t.ResultValue === 0 ? t.ResultValue : ''}
                                                                disabled={true}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                                ))
                                                : 
                                                testAndResultsArray && testAndResultsArray.length > 0 && testAndResultsArray.map(t => (
                                                <div className="row">
                                                    <div className={hasAdditionalResultValue ? "col-4 pl-md-0 ml-md-0" :  "col-5 pl-md-0 ml-md-0"}>
                                                        {buildRow("Test",
                                                            <input className="form-control ml-2 ml-md-0"
                                                                type={"text"}
                                                                name={t.Test}
                                                                value={t.Test}
                                                                disabled={true}
                                                            />
                                                        )}
                                                    </div>
                                                    <div className={hasAdditionalResultValue ? "col-4 ml-md-0" : "col-6 ml-md-0"}>
                                                        {buildRow("Result",
                                                            <input className="form-control ml-2 ml-md-0"
                                                                type={"text"}
                                                                name={t.Result ? t.Result : ''}
                                                                value={t.Result ? t.Result : ''}
                                                                disabled={true}
                                                            />
                                                        )}
                                                    </div>


                                                    {hasAdditionalResultValue && (
                                                    <div className="col-4 ml-md-0">
                                                        {buildRow("Result Value",
                                                            <input className="form-control ml-2 ml-md-0"
                                                                type={"text"}
                                                                name={t.ResultValue || t.ResultValue === 0 ? t.ResultValue : ''}
                                                                value={t.ResultValue || t.ResultValue === 0 ? t.ResultValue : ''}
                                                                disabled={true}
                                                            />    
                                                        )}
                                                    </div>
                                                    )}
                                                </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer mb-2 mr-2 ml-0" style={{backgroundColor: 'transparent', borderTop: 'none'}}>
                              <button type="button"
                                  onClick={() => { this.openDocuments() }}
                                  className={'btn btn-success float-right mb-2'}
                              >Documents
                              </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
        )
    }
}

export default ViewTestInfoModal;